// ============================================================================
// Componente: FinanceiroRelatorios.js
// Objetivo: Hub de relatórios prontos do módulo Financeiro (espelha o
//           AuditoriaRelatorio/FiscalRelatorios). Lista os relatórios em
//           cards; ao clicar, abre o relatório com filtros próprios.
//           Hoje há um: Fechamento Mensal (visão Financeira). Espaço para crescer.
// Conteúdo embutido: renderizado DENTRO do casco Financeiro.js.
// ============================================================================

import React, { useState } from 'react';
import { BarChart3, ChevronRight } from 'lucide-react';
import FinanceiroRelatorioFechamento from './FinanceiroRelatorioFechamento';

const RELATORIOS = [
    {
        id: 'fechamento',
        titulo: 'Fechamento Mensal (Financeiro)',
        descricao: 'Faturamento consolidado do mês na visão financeira, por grupo de loja. Visualize na tela e exporte em Excel.',
        cor: '#0d7a74',
        bg: '#ccfbf1',
    },
];

const FinanceiroRelatorios = () => {
    const [ativo, setAtivo] = useState(null);

    if (ativo === 'fechamento') {
        return <FinanceiroRelatorioFechamento onVoltar={() => setAtivo(null)} />;
    }

    return (
        <div>
            <h3 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#0f172a' }}>Relatórios Financeiros</h3>
            <p style={{ margin: '6px 0 24px', color: '#64748b' }}>
                Selecione um relatório para gerar com seus filtros.
            </p>

            <div style={{ display: 'grid', gap: 12 }}>
                {RELATORIOS.map((r) => (
                    <div
                        key={r.id}
                        onClick={() => setAtivo(r.id)}
                        style={{
                            display: 'flex', alignItems: 'center', gap: 16,
                            padding: 20, background: '#fff', border: '1px solid #e2e8f0',
                            borderRadius: 12, cursor: 'pointer', transition: 'all .15s',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.borderColor = r.cor; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.transform = 'translateY(0)'; }}
                    >
                        <div style={{ padding: 12, background: r.bg, borderRadius: 10 }}>
                            <BarChart3 size={24} color={r.cor} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 17, fontWeight: 800, color: '#0f172a' }}>{r.titulo}</div>
                            <div style={{ marginTop: 4, color: '#64748b', fontSize: 14 }}>{r.descricao}</div>
                        </div>
                        <ChevronRight size={20} color="#cbd5e1" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FinanceiroRelatorios;
